export const trafficTypeList = [
    { value: 'pedestrian', text: 'Voetganger', translateKey: 'trafficType.pedestrian' },
    { value: 'cyclist', text: 'Fietser', translateKey: 'trafficType.cyclist' },
    { value: 'car', text: 'Auto', translateKey: 'trafficType.car' },
    { value: 'train', text: 'Trein', translateKey: 'trafficType.train' },
    { value: 'tram', text: 'Tram', translateKey: 'trafficType.tram' },
    { value: 'subway', text: 'Metro', translateKey: 'trafficType.subway' },
    { value: 'vessel', text: 'Vaartuigen', translateKey: 'trafficType.vessel' },
    { value: 'non', text: 'Geen', translateKey: 'trafficType.non' },
];

export function trafficTypeToString(trafficType: string) {
    const types = trafficType ? trafficType.split(',') : [];

    const result: string[] = [];

    for (const currentType of types) {
        const foundType = trafficTypeList.find((i) => i.value === currentType);
        if (foundType) {
            result.push(foundType.text);
        }
    }
    return result.join(', ');
}
